<template>
	<NuxtLink
		ref="linkRef"
		:to="url"
		:title="title"
		:target="target"
		class="cursor-pointer inline"
		@click="onClick"
	>
		<slot />
	</NuxtLink>
</template>

<script lang="ts" setup>
import type { UrlType } from '#base/core/types/UrlType';

const {
	url,
	title,
	newTab = false,
} = defineProps<UrlType>();

const target = computed(() => (newTab ? '_blank' : '_self'));

const linkRef = ref<HTMLAnchorElement | null>(null);

defineExpose({
	linkRef,
});

const onClick = (e: MouseEvent) => {
	if (url.startsWith('#')) {
		e.preventDefault();
		const element = document.querySelector(url);
		if (element) {
			element.scrollIntoView({
				behavior: 'smooth',
			});
		}
	}
};
</script>
